import { useWorkspaceId } from '../use-workspace-id'
import { useWorkspaceQuery } from './graphql/workspace'

export const useWorkspaceResult = () => {
  const workspaceId = useWorkspaceId()

  const { data, loading } = useWorkspaceQuery({
    variables: {
      id: workspaceId!,
    },
    skip: !workspaceId,
  })

  // The route param is empty on the first client render, and the query is
  // skipped until it arrives, so an unresolved id counts as loading.
  return { workspace: data?.workspace, loading: !workspaceId || loading }
}

export const useWorkspace = () => useWorkspaceResult().workspace
